const apiParams = {
  namespaced: true,
  state: {
    jwtToken: '',
    treatmentConsultationSeq: '',
    treatmentSerialNumber: '',
  },
  getters: {
    jwtToken: state => state.jwtToken,
    treatmentConsultationSeq: state => state.treatmentConsultationSeq,
    treatmentSerialNumber: state => state.treatmentSerialNumber,
  },
  mutations: {
    setJwtToken: (state, payload) => {
      if (state.jwtToken.length > 0) {
        return
      }
      state.jwtToken = payload
    },
    setTreatmentConsultationSeq: (state, payload) => {
      if (state.treatmentConsultationSeq.length > 0) {
        return
      }
      state.treatmentConsultationSeq = payload
    },
    setTreatmentSerialNumber: (state, payload) => {
      if (state.treatmentSerialNumber.length > 0) {
        return
      }
      state.treatmentSerialNumber = payload
    },
  },
  actions: {
    setJwtToken: ({ commit }, value) => commit('setJwtToken', value),
    setTreatmentConsultationSeq: ({ commit }, value) => commit('setTreatmentConsultationSeq', value),
    setTreatmentSerialNumber: ({ commit }, value) => commit('setTreatmentSerialNumber', value),
  },
};

export default apiParams;
